import { useEffect, useState } from "react";
import { generateApplyURL } from "@/utils/helpers/generate-apply-url";

export const useApplyURL = (brandId: string, courseId: string) => {
  const [applyURL, setApplyURL] = useState<string | null>(null);

  useEffect(() => {
    if (!brandId || !courseId) return;

    const url = generateApplyURL(brandId, courseId);
    setApplyURL(url);
  }, [brandId, courseId]);

  return applyURL;
};
